import React from "react";
import "./Input.css";
import { InputValidationState } from "../../../types";

interface InputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: string;
  validationState?: InputValidationState;
  errorMessage?: string;
  label?: string;
  name?: string;
  required?: boolean;
  maxLength?: number;
  className?: string;
}

const Input: React.FC<InputProps> = ({
  value,
  onChange,
  onFocus,
  placeholder = "",
  type = "text",
  validationState = "default",
  errorMessage = "",
  label = "",
  name = "",
  required = false,
  maxLength,
  className = "",
}) => {
  return (
    <div className={`input-container ${className}`}>
      {label && (
        <label className="input-label">
          {label}
          {required && <span className="input-required">*</span>}
        </label>
      )}
      <div className={`input-wrapper input-${validationState}`}>
        <input
          type={type}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          placeholder={placeholder}
          name={name}
          required={required}
          maxLength={maxLength}
          className="input-field"
        />
      </div>
      {validationState === "error" && errorMessage && (
        <p className="input-error-message">{errorMessage}</p>
      )}
    </div>
  );
};

export default Input;
